import "core-js/modules/es.function.name";
import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import useRedirect from '../useRedirect';

function withRedirect() {
  return function withRedirectHoc(BaseComponent) {
    function Wrapper(props) {
      var setRedirect = useRedirect();
      return React.createElement(BaseComponent, _extends({}, props, {
        setRedirect: setRedirect
      }));
    }

    Wrapper.displayName = "WithRedirect".concat(BaseComponent.displayName || BaseComponent.name || 'Component');
    return Wrapper;
  };
}

export default withRedirect;